import React from 'react';
import Page from '@service-victoria/component-library/components/Page';
import Text from '@service-victoria/component-library/components/Text';
import styled from 'styled-components';
import { constants } from 'utils';
import bannerImg from 'assets/melbourne-city-at-night.png';
import { TextBodyWithInlineLink } from './styled';

const PageWrapper = styled(Page)``;

export default function Privacy() {
  return (
    <PageWrapper
      title={constants.Page.title}
      showFooter
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}
      loading={false}
      opacityBetweenLoading={0}>
      <Text.Heading.H1 style={{ fontWeight: 'bold' }}>Collection notice</Text.Heading.H1>
      <Text.Body>
        <TextBodyWithInlineLink>
          We’re Service Victoria. We are the Victorian Government’s customer service agency. Here’s
          how to{' '}
          <Text.Link href={constants.externalLinks.svContact} value='contact us.' target='_blank' />
        </TextBodyWithInlineLink>
      </Text.Body>
      <Text.Body>
        We’re collecting your personal info to help you apply for a $200 voucher reimburse the cost
        of eligible tourism activities between December 2020 and June 2021. This scheme encourages
        Victorian residents to visit metropolitan Melbourne, stay overnight, support tourism
        businesses and the Melbourne economy.
      </Text.Body>
      <Text.Body>
        We collect personal information you give us including your name, contact phone number, email
        and home address. All the fields in the Melbourne travel voucher application must be
        completed. Your form can’t be processed without all the necessary information.
      </Text.Body>
      <Text.Body>
        We’ll pass this information to the Department of Jobs Precincts &amp; Regions so they can
        process your application, keep a record of any voucher issued, and help process your
        reimbursement when you return to claim your $200.
      </Text.Body>
      <Text.Body>
        <TextBodyWithInlineLink>
          We may also share your personal info with others where authorised by law.{' '}
          <Text.Link
            href={constants.externalLinks.svPrivacy}
            value='Read Service Victoria’s full privacy statement.'
            target='_blank'
          />
        </TextBodyWithInlineLink>
      </Text.Body>
      <Text.Body>
        Once we have passed on the personal information you provide in your Melbourne travel voucher
        application we delete it from our system. We can’t update or amend your details as we don’t
        keep a copy.
      </Text.Body>
      <Text.Body>
        The Department of Jobs Precincts &amp; Regions may also verify the information in your
        application with VicRoads for the verification of your driver licence or proof of age card,
        or with the Department of Health &amp; Human Services for verification of your Seniors Card.
      </Text.Body>
      <Text.Body>
        <TextBodyWithInlineLink>
          For more info on how the Department of Jobs Precincts &amp; Regions handles your personal
          information,{' '}
          <Text.Link
            href={constants.externalLinks.djprPrivacy}
            value='read their privacy statement.'
            target='_blank'
            showExtraLink
          />
          This statement explains how you can access the personal info they hold about you at any
          time and request to update, correct or amend your personal information.
        </TextBodyWithInlineLink>
      </Text.Body>
      <Text.Body>
        We won&apos;t use your info for marketing or other purposes. Only if you opt-in will your
        email address be added to the Visit Victoria mailing list to send you useful ideas about
        things to do in metropolitan Melbourne. They won’t sell or give away your email, and you can
        unsubscribe any time.
      </Text.Body>
    </PageWrapper>
  );
}
